<div class="row">
    <div class="col-md-7">
        <div class="d-flex align-items-center mb-3">
            <h6 class="loginHeadingText me-2 mb-0">STORE LIST</h6>
            <a (click)="showReminderDialog()">
                <img src="assets/images/mail_icon.png" alt="email" class="emailicon" title="Send Reminder Email">
            </a>
        </div>
        <div class="row mb-3 align-items-center justify-content-between">
            <div class="col-md-8">

                <div class="d-flex align-items-center">
                    <div class="me-2">
                        <input type="radio" name="radiolist1" [disabled]="disableAll"
                            (change)="onRadioClick('Option 1', $event)" [checked]="rbtnLeft" />
                    </div>
                    <div>
                        <p class="text-blue mb-0">Download the most updated store list and upload the ones required</p>
                    </div>
                </div>
            </div>

            <div class="col-md-1 text-end">
                <a href="#" (click)="downloadExcel($event)">
                    <img src="assets/images/download_kkk.png" height="30px" width="30px" alt="">
                </a>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <label for="" class="mb-1">UPLOAD STORE LIST</label>
                <div class="input-group custom-file-button">

                    <input [disabled]="disableAll==true? true: (disableLeftPannel== true? true: false)" type="file"
                        class="form-control" #storeFileInput id="storeFileInput" accept=".xls,.xlsx"
                        (change)="onFileSelected($event)">
                    <label class="input-group-text" for="storeFileInput">UPLOAD</label>
                </div>
            </div>
        </div>
        <!-- 
        <app-flexible-file-upload
            [acceptedFileTypes]="'.xlsx,.xls,.csv,.txt,.pdf'"
            [showAdditionalInfo]="true"
            [allowMultipleFiles]="true"
            (fileUploaded)="handleFileUpload($event)">
            </app-flexible-file-upload> -->
        <div class="row mb-3 mt-3">
            <div class="col-md-2">
                <img src="assets/images/close_mark.svg" alt="" (click)="onDelete()" *ngIf="isFileUploaded">
            </div>
            <div class="col-md-8 ps-0">
                <a href="#" class="fw-bold" style="color:#0c9ef1; text-decoration: none;"
                    (click)="downLoadExcelPreview($event)">
                    {{fileName}}</a>
            </div>
            <div class="col-md-2 text-end">
                <p class="mb-0">{{displayTotalCount}}</p>
            </div>
        </div>

        <div class="alert alert-danger p-2" role="alert" *ngIf="errorDetails.length > 0">
            <div class="row">
                <div class="col-md-2 align-self-center text-center">
                    <img src="images/close_mark.svg" alt="">
                </div>
                <div class="col-md-8 ps-0">
                    <a href="#" class="fw-bold" style="color:#ff000b; text-decoration: none;">{{errorDetails}}</a>
                </div>
                <div class="col-md-2 text-center align-self-center">
                    <!-- <p class="mb-0 fw-bold" style="color:#ff000b; ">(1590)</p> -->
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-2 text-center">
        <h6 class="orText mt-30">OR</h6>
    </div>

    <div class="col-md-3">
        <div class="mt-35px rounded-1">
            <div class="d-flex">
                <div class="me-2">
                    <input type="radio" name="radiolist1" [disabled]="disableAll"
                        (change)="onRadioClick('Option 2', $event)" [checked]="rbtnRight" />
                </div>
                <div>
                    <p class="text-blue">COPY STORE #</p>
                </div>
            </div>
            <textarea class="form-control h-200px" spellcheck="false"
                [disabled]="disableAll==true? true: (disableRightPannel== true? true: false)"
                placeholder="Copy the 6 digit store numbers here" [(ngModel)]="storeNos"
                (ngModelChange)="onAnyFieldValueChange($event)" (input)="storeNosInput()"
                style="cursor:pointer"></textarea>
        </div>
        <div class="row mb-1 mt-1" *ngIf="validStoresCount > 0">
            <div class="d-flex">
                <div class="me-2">
                    <img src="assets/images/close_mark.svg" alt="" (click)="onCopyStoreDelete()">
                </div>
                <div class="ps-0">
                    <a href="#" class="fw-bold" style="color:#0c9ef1; text-decoration: none;"
                        (click)="downLoadCopyStoreExcelPreview($event)">
                        StoresList.xlsx</a>
                </div>
                <div class="text-end">
                    <p class="mb-0">({{validStoresCount}})</p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-7"></div>
    <div class="col-md-5">
        <div class="d-flex align-items-center text-end">
            <!-- <img *ngIf="showLoaderForValidateStores" src="assets/images/loader_btn.gif" class="buttonsmallIcon mr-2"
                alt="Loader"> -->

            <button class="btn btn-sm executionStart mt-2 w-100" data-bs-toggle="modal" [disabled]="disableAll"
                (click)="btnValidateStore()">
                VALIDATE STORES
            </button>
        </div>
    </div>
</div>

<div class="modal fade" id="staticBackdrop_four" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdrop_fourLabel" aria-hidden="true" *ngIf="showModalPopup">
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
        <div class="modal-content">
            <div class="modal-header custommodal-header py-2">
                <h1 class="modal-title modalTitle" id="staticBackdrop_fourLabel">INVALID STORES LIST ( Count:
                    {{inActiveStores.length}})</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body pb-2">
                <div class="table-responsive tableFixHead">
                    <table class="table datatable border-x-0 mb-4">
                        <thead>
                            <tr class="subheaderrr">

                                <th class="py-1" width="8%">STORE#</th>
                                <th class="py-1" width="10%"> TDLINX</th>
                                <th class="py-1" width="20%">StoreName</th>
                                <th class="py-1" width="20%">Street</th>
                                <th class="py-1" width="15%">City</th>
                                <th class="py-1" width="10%">State</th>
                                <th class="py-1" width="10%">Zip</th>
                                <th width="10%" class="border-end-0">Status</th>


                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor=" let item of inActiveStores">

                                <ng-container>
                                    <td class="table-row">{{item.storeNumber}}</td>
                                    <td class="table-row">{{item.tdlinx}}</td>
                                    <td class="table-row">{{item.storeName}}</td>
                                    <td class="table-row">{{item.street}}</td>
                                    <td class="table-row">{{item.city}}</td>
                                    <td class="table-row">{{item.state}}</td>
                                    <td class="table-row">{{item.zip}}</td>
                                    <td class="table-row">{{ (item.status == 1 ? 'Invalid': (item.status == 2 ?
                                        'Active' : 'Inactive')) }}</td>
                                </ng-container>
                                <!-- <ng-container *ngIf="item.status == 3"> <td>{{item.storeNumber}}</td>
                                        <td>{{item.tdlinx}}</td>
                                        <td>{{item.storeName}}</td>
                                        <td>{{item.street}}</td>
                                        <td>{{item.city}}</td>
                                        <td>{{item.state}}</td>
                                        <td>{{item.zip}}</td>
                                        <td>{{ (item.status == 1 ? 'Invalid': (item.status == 2 ? 'Active' : 'Inactive')) }}</td>
                                    </ng-container> -->
                            </tr>
                        </tbody>
                    </table>
                </div>



            </div>
            <div class="modal-footer">
                <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
                <button class="btn progressBtn ps-2" role="button" (click)="updateStoreNosAndExcludeInvalidones()">
                    EXCLUDE INVALID STORES
                </button>
            </div>
        </div>
    </div>
</div>

<app-store-state-modal [showModal]="showModalPopupForStates" [stores]="addedStores" [isNewProject]="isNewProject"
    (saveAndNotify)="notifyIsoAdminForStores()" (closeModal)="showModalPopupForStates = false">
</app-store-state-modal>